const menu = {
    label: 'Unidades de Atendimento',
    icon: 'building',
    to: '/expressos/unidades',
    rules: ['EXPR-UNID-00'],
};

export default menu;
